import { CommonModule } from '@angular/common'
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { MatTableModule } from '@angular/material/table'
import { MatTabsModule } from '@angular/material/tabs'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import {
  FeaturesConfigModule,
  I18nModule,
  UrlModule,
  ConfigModule,
  provideConfig,
} from '@spartacus/core'
import { RouterModule } from '@angular/router'

import { SavedCartComponent } from './saved-cart.component'
import { CreateSavedCartDialogComponent } from './create-saved-cart-dialog/create-saved-cart-dialog.component'
import { DeleteSavedCartDialogComponent } from './delete-saved-cart-dialog/delete-saved-cart-dialog.component'
import { RestoreSavedCartDialogComponent } from './restore-saved-cart-dialog/restore-saved-cart-dialog.component'
import { ExtendCartExpiryDialogComponent } from './extend-cart-expiry-dialog/extend-cart-expiry-dialog.component'

import {
  SpinnerModule,
  IconModule,
  FormErrorsModule,
  MediaModule,
  DIALOG_TYPE,
} from '@spartacus/storefront'
import { SavedCartDetailComponent } from './saved-cart-detail/saved-cart-detail.component'
import { SavedCartService } from './saved-cart.service'
import { CustomGlobalMsgComponent } from './custom-global-msg/custom-global-msg.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { RestoreSavedQuoteCartDialogComponent } from './restore-saved-quote-cart-dialog/restore-saved-quote-cart-dialog.component'
import { environment } from '../../../../environments/environment'
import { ComponentLibraryWrapperModule } from '../../../component-library-wrapper.module'
import { VS_LAUNCH_CALLER } from '../../config/dialog.config'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerModule,
    FeaturesConfigModule,
    UrlModule,
    IconModule,
    I18nModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule,
    MatTabsModule,
    NgSelectModule,
    FormsModule,
    ComponentLibraryWrapperModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['savedCart'],
        },
      },
    }),
    FormErrorsModule,
    RouterModule,
    MediaModule,
  ],
  providers: [
    SavedCartService,
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.CREATE_SAVED_CART]: {
          inlineRoot: true,
          component: CreateSavedCartDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.DELETE_SAVED_CART]: {
          inlineRoot: true,
          component: DeleteSavedCartDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.EXTEND_CART_EXPIRY]: {
          inlineRoot: true,
          component: ExtendCartExpiryDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.RESTORE_SAVED_CART]: {
          inlineRoot: true,
          component: RestoreSavedCartDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.RESTORE_SAVED_QUOTE_CART]: {
          inlineRoot: true,
          component: RestoreSavedQuoteCartDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
  declarations: [
    SavedCartComponent,
    CreateSavedCartDialogComponent,
    DeleteSavedCartDialogComponent,
    RestoreSavedCartDialogComponent,
    ExtendCartExpiryDialogComponent,
    SavedCartDetailComponent,
    CustomGlobalMsgComponent,
    RestoreSavedQuoteCartDialogComponent,
  ],
  exports: [
    SavedCartComponent,
    CreateSavedCartDialogComponent,
    DeleteSavedCartDialogComponent,
    RestoreSavedCartDialogComponent,
    ExtendCartExpiryDialogComponent,
    SavedCartDetailComponent,
    CustomGlobalMsgComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SavedCartModule {}
